module.exports = __webpack_public_path__ + "img/video-file-icon.376f40af.svg";